<template>

  <v-dialog v-model="enabled_" :max-width="options.createMaxWidth || '800px'">
    <slot name="activator" slot="activator"></slot>
    <v-card>
      <v-card-title class="headline">{{ options.title }}</v-card-title>
      <v-card-text>
        <v-container fluid="fluid" grid-list-xl="grid-list-xl"></v-container>
        <v-flex v-for="(c, index) in columns" :key="index">
          <component v-if="c.editComponent"
                     :is="c.editComponent"
                     :item="item_"
                     :label="c.text"
                     v-model="item_[c.value]"
                     :restrict="true"></component>
          <v-text-field v-else-if="item_[c.value] && c.subvalue"
                        v-model="item_[c.value][c.subvalue]"
                        :label="c.text"
                        :placeholder="c.placeholder"></v-text-field>
          <v-text-field v-else-if="!c.subvalue && c.value"
                        v-model="item_[c.value]"
                        :label="c.text"
                        :placeholder="c.placeholder"></v-text-field>
          <div>
            <p v-if="c.warning" class="error-message">{{ c.warning }}</p>
          </div>
        </v-flex>
        <v-flex>
          <div class="error-message">{{ errorMessage }}</div>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
        <v-btn :color="saveDisabled ? 'grey' : 'primary'" flat="flat" @click.native="save">{{ dialogButton }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'ItemDialog',
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      errorMessage: null,
      item_: {},
      saveDisabled: false
    }
  },
  computed: {
    columns () {
      if (!this.options || !this.options.columns) {
        return []
      }
      return this.options.columns
        .filter(c => this.editing ? (c.editable !== false) : (c.creatable !== false))
        .sort((a, b) => {
          if (a.editPosition === b.editPosition) {
            return 0
          } else if (!a.editPosition) {
            return 1
          } else if (!b.editPosition) {
            return -1
          }
          return a.editPosition - b.editPosition
        })
    },

    dialogButton () {
      return this.editing ? 'Edit' : 'Create'
    },

    enabled_: {
      get () {
        return this.enabled
      },
      set (v) {
        this.$emit('update:enabled', v)
      }
    },

    editing () {
      return this.item !== undefined && this.item !== null
    }
  },
  methods: {
    close () {
      this.enabled_ = false
    },

    save () {
      if (!this.saveDisabled) {
        this.saveDisabled = true

        let cb = this.options.applyCreate

        if (this.editing) {
          cb = this.options.applyEdit
        }

        cb(this.item_)
          .then(val => {
            if (!this.editing) {
              this.$emit('created', val)
            }
            this.close()
            this.saveDisabled = false
          })
          .catch(err => {
            this.errorMessage = err
            console.error(err)
            this.saveDisabled = false
          })
      }
    }
  },
  watch: {
    item () {
      if (this.item) {
        this.item_ = JSON.parse(JSON.stringify(this.item))
      } else {
        this.item_ = {}
      }
    },

    enabled_ (val, old) {
      if (!val && old) {
        this.item_ = {}
        this.errorMessage = null
        this.saveDisabled = false
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .error-message {
    color: red;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/ItemDialog.vue